import * as t from "../actions";

const initialFormatState: IFormatState = {
  name: "",
  filename: "",
  description: "",
  extension: "csv",
  delimiter: ",",
  compressed: false,
  duration: "one_day"
};

const getFileExtension = (stringInp: string) => {
  switch (stringInp) {
    case ",":
      return "csv";
    case "\\t":
      return "tsv";
    case "|":
      return "psv";
    default:
      return "";
  }
};

export default function (state = initialFormatState, action: IPayload) {
  switch (action.type) {
    case t.EDIT_NAME:
      return {
        ...state,
        name: action.payload
      };

    case t.EDIT_FILENAME: {
      return {
        ...state,
        filename: action.payload
      };
    }

    case t.EDIT_DESCRIPTION:
      return {
        ...state,
        description: action.payload
      };

    case t.EDIT_DELIMITER:
      return {
        ...state,
        delimiter: action.payload,
        extension: getFileExtension(action.payload)
      };

    case t.TOGGLE_COMPRESSED:
      return {
        ...state,
        compressed: !state.compressed
      };

    case t.EDIT_DURATION:
      return {
        ...state,
        duration: action.payload
      };

    case t.ADD_REPORT:
      return {
        name: action.payload.name,
        filename: action.payload.filename,
        description: action.payload.description,
        extension: action.payload.extension,
        delimiter: action.payload.delimiter,
        compressed: action.payload.compressed,
        duration: action.payload.duration
      };

    case t.FLUSH_REPORT:
      return initialFormatState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/reducer/format.ts